var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('i-col',{attrs:{"span":"24"}},[_c('div',{staticStyle:{"width":"100%","height":"650px"},attrs:{"id":"home_page_map"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }